'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Logo = require('./Logo');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Logo).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }